"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickImportSampleRows = exports.IMPORT_SAMPLE_LEADING_ROW_COUNT = exports.IMPORT_SAMPLE_ROW_COUNT = void 0;
exports.IMPORT_SAMPLE_ROW_COUNT = 50;
exports.IMPORT_SAMPLE_LEADING_ROW_COUNT = 10;
const UINT32_RANGE = 4294967296;
const seededRandom = (seed, step) => {
    const state = (seed + Math.imul(step + 1, 0x6d2b79f5)) >>> 0;
    const mixedOnce = Math.imul(state ^ (state >>> 15), state | 1);
    const mixedTwice = mixedOnce ^ (mixedOnce + Math.imul(mixedOnce ^ (mixedOnce >>> 7), mixedOnce | 61));
    return ((mixedTwice ^ (mixedTwice >>> 14)) >>> 0) / UINT32_RANGE;
};
const pickImportSampleRows = (rows, seed, sampleSize = exports.IMPORT_SAMPLE_ROW_COUNT, leadingSize = exports.IMPORT_SAMPLE_LEADING_ROW_COUNT) => {
    if (rows.length <= sampleSize) {
        return [...rows];
    }
    const pickCount = sampleSize - leadingSize;
    const candidateIndexes = Array.from({ length: rows.length - leadingSize }, (_, offset) => leadingSize + offset);
    for (let pickIndex = 0; pickIndex < pickCount; pickIndex++) {
        const swapIndex = pickIndex + Math.floor(seededRandom(seed, pickIndex) * (candidateIndexes.length - pickIndex));
        [candidateIndexes[pickIndex], candidateIndexes[swapIndex]] = [
            candidateIndexes[swapIndex],
            candidateIndexes[pickIndex],
        ];
    }
    const pickedIndexes = candidateIndexes.slice(0, pickCount).sort((first, second) => first - second);
    return [...rows.slice(0, leadingSize), ...pickedIndexes.map((index) => rows[index])];
};
exports.pickImportSampleRows = pickImportSampleRows;
